<template>
    <div>
        <div class="card">
            <router-link :to="{ path: '/post/'+ id }">
                <div class="tags category">
                    <span>
                        <Badge status="processing" :color="colorValue" :text="categories[0].name" /> 
                    </span>
                </div>
                <div>
                    <div v-if="isLoading" class="loading"></div>
                    <img v-show="isLoaded" :src="image" class="blogImage" @load="loaded"/>
                </div>
                <div class="titleText">
                    <span v-html="title"></span>
                </div>
                <div class="timeLastUpdated">
                    <span>{{GetRelatableTime(updatedAt)}}</span>
                </div>
            </router-link>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        image:String,
        title:String,
        updatedAt: String,
        categories:Array,
        author:Object,
        id:Number,
        colorValue:String
    },
    methods: {
        GetRelatableTime(time){
            return this.TimeDiff(new Date(), new Date(time).getTime())
        },
        TimeDiff(curr, prev) {
            var ms_Min = 60 * 1000; // milliseconds in Minute
            var ms_Hour = ms_Min * 60; // milliseconds in Hour
            var ms_Day = ms_Hour * 24; // milliseconds in day
            var ms_Mon = ms_Day * 30; // milliseconds in Month
            var ms_Yr = ms_Day * 365; // milliseconds in Year
            var diff = curr - prev; //difference between dates.
            // If the diff is less then milliseconds in a minute
            if (diff < ms_Min) {
                return Math.round(diff / 1000) + ' seconds ago';
  
                // If the diff is less then milliseconds in a Hour
            } else if (diff < ms_Hour) {
                return Math.round(diff / ms_Min) + ' minutes ago';
  
                // If the diff is less then milliseconds in a day
            } else if (diff < ms_Day) {
                return Math.round(diff / ms_Hour) + ' hours ago';
  
                // If the diff is less then milliseconds in a Month
            } else if (diff < ms_Mon) {
                return 'Around ' + Math.round(diff / ms_Day) + ' days ago';
  
                // If the diff is less then milliseconds in a year
            } else if (diff < ms_Yr) {
                return 'Around ' + Math.round(diff / ms_Mon) + ' months ago';
            } else {
                return 'Around ' + Math.round(diff / ms_Yr) + ' years ago';
            }
        },
        loaded(){
            this.isLoading=false;
            this.isLoaded=true;
        }
    },
    data(){
        return {
            isLoading:true,
            isLoaded: false
        }
    }
}
</script>
<style scoped>
.card{
  height: 100%;
  min-height:300px;
  width: 100%;
  background-color: rgb(250, 249, 249);
  display: inline-block;
  border-radius: 10px 10px 0px 0px;
}
.tags.category{
    font-size: 14px;
    margin: 10px;
    font-family: 'Times New Roman', Times, serif;
    font-weight:500;
    display: flex;
}
.dot {
  height: 5px;
  width: 5px;
  background-color: purple;
  border-radius: 50%;
  display: inline-block;
}
.blogImage{
    max-width: 100%;
    height: auto;
}
.titleText{
    padding: 20px;
    font-family: 'Oswald', sans-serif;
    font-weight: 600
}
.timeLastUpdated{
    padding-left: 20px;
    padding-bottom: 5px;
    font-size: 12px;
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 25px;
}
.loading{
    align-items: center;
    background: transparent url('https://miro.medium.com/max/1400/1*CsJ05WEGfunYMLGfsT2sXA.gif') center no-repeat;
    height: 130px;
    width: 100%;
}
</style>